import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { EActiveView } from '../../types/view';
import { ERegisterOrAuthStatus, ESendValidationCodeStatus } from '../../types/phoneAuth';
import { PHONE_AUTH_REGISTER_OR_AUTHORIZE_TYPE, PHONE_AUTH_SEND_VALIDATION_CODE_TYPE } from '../../constants/action_types';
import { changeView } from '../view';
import { sendValidationCode as sendValidationCodeApi } from '../../api/sendValidationCode';
export function sendValidationCode() {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, _getState, context) {
      var _getState2, activeView, phone, res;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch({
                status: ESendValidationCodeStatus.Loading,
                type: PHONE_AUTH_SEND_VALIDATION_CODE_TYPE
              }); // сбрасываем ошибки авторизации с помощью смс кода

              dispatch({
                status: ERegisterOrAuthStatus.Initial,
                type: PHONE_AUTH_REGISTER_OR_AUTHORIZE_TYPE
              });
              _getState2 = _getState(), activeView = _getState2.view.active, phone = _getState2.phoneAuth.phone;
              _context.prev = 3;
              _context.next = 6;
              return sendValidationCodeApi(context.httpApi, phone);

            case 6:
              res = _context.sent;

              if (res.statusCode === 200) {
                dispatch({
                  status: ESendValidationCodeStatus.Succeed,
                  type: PHONE_AUTH_SEND_VALIDATION_CODE_TYPE,
                  secondsToRetry: res.response.secondsToRetry || 60,
                  timeStamp: new Date().getTime()
                });

                if (activeView !== EActiveView.PhoneAuthValidateSms) {
                  dispatch(changeView(EActiveView.PhoneAuthValidateSms));
                }
              } else {
                dispatch({
                  status: ESendValidationCodeStatus.Failed,
                  type: PHONE_AUTH_SEND_VALIDATION_CODE_TYPE,
                  error: res.response.message
                });
              }

              _context.next = 14;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](3);
              context.logger.error(_context.t0);
              dispatch({
                status: ESendValidationCodeStatus.Failed,
                type: PHONE_AUTH_SEND_VALIDATION_CODE_TYPE,
                error: 'Произошла непредвиденная ошибка'
              });

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 10]]);
    }));

    return function (_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }();
}